import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { CSSTransition } from 'react-transition-group';
import { Select } from 'antd';
import { Form, useParams } from "react-router-dom";

import Flex from "../../core/Flex";
import useAdminApplicationStore from "../../../store/useAdminApplicationStore";
import useAdminApplicationDetailStore from "../../../store/useAdminApplicationDetailStore";
import useModalStore from "../../../store/useModalStore";
import useAuthAdminStore from "../../../store/useAuthAdminStore";
import FormTitle from "../../form/FormTitle";
import FormText from "../../form/FormText";
import FormRemark from "../../form/FormRemark";
import FormButtonPrimary from "../../form/FormButtonPrimary";
import FormButtonSecondary from "../../form/FormButtonSecondary";
import Divider from "../../core/Divider";
import { ContentComposeEmail } from "../../admin/application/Email";
import withErrorHandling from "../../../function/withErrorHandling";
import downloadBase64File from "../../../function/downloadBase64File";

function RequestStatus() {
  const { t } = useTranslation();
  const { aid } = useParams();
  const { isCSTeam } = useAuthAdminStore();
  const { openModalConfirm, closeModalConfirm, openModalInfo } = useModalStore();
  const { data, admGetPreAuthForm, openEmailTemplate, admGeneratePDF } = useAdminApplicationDetailStore();
  const { assignStaffList, assignStaffToPreAuthForm } = useAdminApplicationStore();

  const getProgrssStatus = ({
    step,
    intstatus,
    flowType,
  }) => {
    return <Flex gap={8}>
      {step === 1 && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}
      {(step === 2 && (intstatus === "NEW" || intstatus === "SUPPLE" || intstatus === "REVIEW")) && <IconProgress>2</IconProgress>}
      {(step === 2 && (intstatus === "APPROVELOG" || intstatus === "APPROVEPCA" || intstatus === "DECLINED" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}
      {(step === 3 && (intstatus === "NEW" || intstatus === "SUPPLE" || intstatus === "REVIEW")) && <IconProgress>3</IconProgress>}
      {(step === 3 && (intstatus === "APPROVELOG" || intstatus === "APPROVEPCA" || intstatus === "DECLINED" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}

      <Flex direction={"column"} gap={0}>
        {step === 1 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.request")}</FormText>}
        {step === 2 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.progressing")}</FormText>}
        {step === 3 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.result")}</FormText>}

        {step === 1 && <TextGreen>{t("translation:progress.status.submitted")}</TextGreen>}
        {(step === 2 && intstatus === "NEW") && <TextBlue>{t("translation:progress.status.pending_for_checking")}</TextBlue>}
        {(step === 2 && intstatus === "SUPPLE") && <TextBlue>{t("translation:progress.status.pending_for_supplementary_information")}</TextBlue>}
        {(step === 2 && intstatus === "REVIEW") && <TextBlue>{t("translation:progress.status.reviewing_supplementary_information")}</TextBlue>}
        {(step === 2 && (intstatus === "APPROVELOG" || intstatus === "APPROVEPCA" || intstatus === "DECLINED" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <TextBlue>{t("translation:progress.status.checked")}</TextBlue>}
        {(step === 3 && intstatus === "APPROVELOG") && <TextGreen>{t("translation:progress.status.approved_and_LOG_sent")}</TextGreen>}
        {(step === 3 && intstatus === "APPROVEPCA" && flowType === "PCA") && <TextGreen>{t("translation:progress.status.approved")}</TextGreen>}
        {(step === 3 && intstatus === "APPROVEPCA" && flowType === "CHGTOPCA") && <TextRed>{t("translation:progress.status.declined_and_changed_to_PCA")}</TextRed>}
        {(step === 3 && intstatus === "DECLINED") && <TextRed>{t("translation:progress.status.declined")}</TextRed>}
        {(step === 3 && (intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <TextGreen>{t("translation:progress.status.approved_and_LOG_sent")}</TextGreen>}
      </Flex>
    </Flex>
  };

  const loadAdmGetPreAuthForm = withErrorHandling(admGetPreAuthForm);
  const loadAssignStaffToPreAuthForm = withErrorHandling(assignStaffToPreAuthForm);
  const loadEmailTemplate = withErrorHandling(openEmailTemplate);

  const loadAdmGeneratePDF = withErrorHandling(admGeneratePDF);

  return (
    <Flex direction={"column"} alignItems={"flex-start"} gap={24} height={"100%"} width={"100%"} style={{ overflow: "auto" }}>
      <Flex gap={8} justifyContent={"space-between"} width={"100%"}>
        <Flex>
          <Icon32 src={`${process.env.PUBLIC_URL}/images/medical-board-2.png`} alt="Request Status" />
          <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>Request Status</FormTitle>
        </Flex>
        <Flex gap={16} style={{ marginRight: 8 }}>
          <FormText style={{ color: "var(--aia-bx-dark-blue)", fontWeight: "bold" }}>Assigned To:</FormText>
          <Select
            showSearch
            placeholder="Assign"
            optionFilterProp="label"
            style={{ width: 200 }}
            disabled={isCSTeam()}
            value={data?.form?.handleStaff === "" ? null : data?.form?.handleStaff}
            onChange={async (data) => {
              await loadAssignStaffToPreAuthForm(aid, data ?? "");
              await loadAdmGetPreAuthForm(aid);
            }}
            allowClear={true}
            options={assignStaffList.map((item) => {
              return {
                value: item.staffId,
                label: `${item?.staffFirstName} ${item?.staffLastName} (${item?.role})`,
              }
            })}
          />
          {
            (
              (data?.form?.intstatus === "APPROVEPCA" ||
                data?.form?.intstatus === "APPROVELOG" ||
                data?.form?.intstatus === "PENDCHARGE" ||
                data?.form?.intstatus === "SCHCHARGE" ||
                data?.form?.intstatus === "CHARGESETTLE" ||
                data?.form?.intstatus === "OUTCHARGE" ||
                data?.form?.intstatus === "CLAIMSETTLE") && false
            ) &&
            <Flex>
              <DownloadBtn onClick={async () => {
                const file = await loadAdmGeneratePDF("PCA", aid);
                downloadBase64File(file, `${data?.form?.refno}_PCA.pdf`);
              }} title={`${data?.form?.refno}_PCA.pdf`}>View PCA</DownloadBtn>

              <FormButtonPrimary size={"extraSmall"} onClick={async () => {
                await loadEmailTemplate(aid, "RESENDPCA");

                openModalConfirm({
                  title: "Compose Email",
                  modalConfirmPrimaryButtonText: "Send",
                  modalConfirmSecondaryButtonText: "Back",
                  content: <ContentComposeEmail disabled={true} />,
                  closeManually: true,
                  style: { content: { width: 720 } },
                  callback: () => {
                    const { contentComposeEmail_Title, setIsValidEmailTitle } = useAdminApplicationDetailStore.getState();
                    const { admSendEmail } = useAdminApplicationDetailStore.getState();

                    const loadAdmSendEmail = withErrorHandling(admSendEmail);

                    if (!contentComposeEmail_Title) {
                      setIsValidEmailTitle(false);
                    } else {
                      loadAdmSendEmail(aid).then(() => {
                        closeModalConfirm();
                        loadAdmGetPreAuthForm(aid).then(() => {
                          openModalInfo({
                            title: "Compose Email",
                            isShowSuccessIcon: true,
                            text: <FormText>Email has been sent to : <span style={{ color: "var(--aia-bx-blue-2)" }}>{data?.user?.email}</span></FormText>,
                            style: { content: { width: 480 } },
                          });
                        });
                      });
                    }
                  },
                  cancelCallback: () => {

                  },
                });
              }}>
                <Icon20 src={`${process.env.PUBLIC_URL}/images/email2_white.png`} alt="Resend PCA" />
                <FormText style={{ color: "var(--aia-bx-white)" }}>Resend PCA</FormText>
              </FormButtonPrimary>
            </Flex>
          }
        </Flex>
      </Flex>

      <Refno>Reference No.：{data?.form?.refno}</Refno>

      <Flex justifyContent={"flex-start"} alignItems={"flex-start"} gap={40} style={{ flexWrap: "wrap", minWidth: 600, rowGap: 16 }}>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step1_1.Q3")}</FormRemark>
          <FormText>{data?.user?.fullname}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step1_1.Q1")}</FormRemark>
          <FormText>{data?.user?.IDPLNO}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:apply.step1_1.Q2")}</FormRemark>
          <FormText>{data?.user?.IDINSN}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:admin.request.tab.request_status.DOB")}</FormRemark>
          {
            data?.user?.IPBIRY &&
            <FormText>{`${data?.user?.IPBIRY}/${data?.user?.IPBIRM < 10 ? `0${data?.user?.IPBIRM}` : data?.user?.IPBIRM}/${data?.user?.IPBIRD < 10 ? `0${data?.user?.IPBIRD}` : data?.user?.IPBIRD}`}</FormText>
          }
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:admin.request.tab.request_status.nameByMember")}</FormRemark>
          <FormText>{data?.form?.userName}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>{t("translation:admin.request.tab.request_status.dobByMember")}</FormRemark>
          <FormText>{data?.form?.userDOB?.substr(0, 10).replaceAll("-", "/")}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>Submitted Date</FormRemark>
          <FormText>{data?.form?.submitdt?.substr(0, 10).replaceAll("-", "/") ?? "-"}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>Last Update</FormRemark>
          <FormText>{data?.form?.moddt.substr(0, 10).replaceAll("-", "/") ?? "-"}</FormText>
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>Request Type</FormRemark>
          {data?.form?.flowType === "LOG" && <FormText>Pre-authorization</FormText>}
          {data?.form?.flowType === "PCA" && <FormText>PCA</FormText>}
          {data?.form?.flowType === "STP" && <FormText>STP</FormText>}
          {data?.form?.flowType === "CHGTOPCA" && <FormText>Change to PCA</FormText>}
        </Flex>
        <Flex direction={"column"} alignItems={"flex-start"}>
          <FormRemark>Network Doctor</FormRemark>
          <FormText>{data?.form?.attendDoctor ?? "N/A"} ({data?.form?.isBxNetWork || "N"})</FormText>
        </Flex>
      </Flex>

      <Flex justifyContent={"flex-start"} gap={16}>
        {
          getProgrssStatus({
            step: 1,
            intstatus: data?.form?.intstatus,
            flowType: data?.form?.flowType,
          })
        }
        <HDivider />
        {
          getProgrssStatus({
            step: 2,
            intstatus: data?.form?.intstatus,
            flowType: data?.form?.flowType,
          })
        }
        <HDivider />
        {
          getProgrssStatus({
            step: 3,
            intstatus: data?.form?.intstatus,
            flowType: data?.form?.flowType,
          })
        }
      </Flex>

      {
        data?.form?.withOtherApplication === "Y" &&
        <>
          <Divider style={{ width: "100%" }} marginVertical={0} />

          <Flex gap={8}>
            <Icon32 src={`${process.env.PUBLIC_URL}/images/medical-board-2.png`} alt="Second Claim" />
            <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>Second Claim</FormTitle>
          </Flex>

          <Flex justifyContent={"flex-start"} alignItems={"flex-start"} gap={40} style={{ flexWrap: "wrap", minWidth: 600, rowGap: 16 }}>
            <Flex direction={"column"} alignItems={"flex-start"}>
              <FormRemark>{t("translation:admin.request.tab.request_status.second_claim.Q1")}</FormRemark>
              <FormText>{data?.form?.otherPolicyNo}</FormText>
            </Flex>
            {/* <Flex direction={"column"} alignItems={"flex-start"}>
                <FormRemark>{t("translation:admin.request.tab.request_status.second_claim.Q4")}</FormRemark>
                <FormText>-</FormText>
              </Flex> */}
            <Flex direction={"column"} alignItems={"flex-start"}>
              <FormRemark>{t("translation:admin.request.tab.request_status.second_claim.Q6")}</FormRemark>
              <FormText>{data?.form?.otherDependCode ? `${data?.form?.otherInsurNo} (${data?.form?.otherDependCode})` : data?.form?.otherInsurNo}</FormText>
            </Flex>
            {/* <Flex direction={"column"} alignItems={"flex-start"}>
                <FormRemark>{t("translation:admin.request.tab.request_status.second_claim.Q7")}</FormRemark>
                <FormText>-</FormText>
              </Flex> */}
          </Flex>
        </>
      }

      <Divider style={{ width: "100%" }} marginVertical={0} />

      <Flex gap={8}>
        <Icon32 src={`${process.env.PUBLIC_URL}/images/training2.png`} alt="Progress Details" />
        <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>Progress Details</FormTitle>
      </Flex>

      <Flex gap={8} direction={"column"} alignItems={"flex-start"}>
        {
          data?.workflow?.map((item) => {
            return <Flex gap={16} key={item.wkid}>
              <Log>{item.wkmsg}</Log>
              {item.actionby && <LogModby>{item.actionby}</LogModby>}
              <LogDatetime>{item.wkactiondt}</LogDatetime>
            </Flex>
          })
        }

        {
          data?.workflow?.length === 0 && <Log>No progress details</Log>
        }
      </Flex>

      {
        ((data?.form?.flowType === "PCA" || data?.form?.flowType === "STP" )&& false) && <>
          <Divider style={{ width: "100%" }} marginVertical={0} />

          <Flex gap={8}>
            <Icon32 src={`${process.env.PUBLIC_URL}/images/document-tray.png`} alt="STP Log" />
            <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>STP Log</FormTitle>
          </Flex>

          <Flex gap={8} direction={"column"} alignItems={"flex-start"}>
            {
              data?.STPLog?.map((item) => {
                return <Flex gap={16} key={item.id}>
                  <Log>{item.criteria}: {item.result}</Log>
                  <LogDatetime>{item.check_datetime_fmt}</LogDatetime>
                </Flex>
              })
            }

            {
              data?.STPLog?.length === 0 && <Log>No STP Log</Log>
            }
          </Flex>
        </>
      }
    </Flex>
  );
}

const Icon20 = styled.img`
  width: 20px;
  height: 20px;
`;

const Icon32 = styled.img`
  width: 32px;
  height: 32px;
`;

const IconProgress = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--aia-bx-gray-4);
  color: var(--aia-bx-gray-2);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 10px;
`;

const TextGreen = styled(FormText)`
  color: var(--aia-bx-green-60);
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
`;

const TextBlue = styled(FormText)`
  color: var(--aia-bx-dark-blue);
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
`;

const TextRed = styled(FormText)`
  color: var(--aia-bx-red-1);
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
`;

const Refno = styled(FormText)`
  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  color: var(--aia-bx-dark-blue);
`;

const HDivider = styled.div`
  background-color: var(--aia-bx-dark-blue);
  width: 30px;
  height: 1px;
`;

const Log = styled(FormText)`
  color: var(--aia-bx-light-black);
  font-size: 12px;
  line-height: 18px;
  font-weight: bold;
`;

const LogModby = styled(FormRemark)`
  font-size: 12px;
  line-height: 18px;
`;

const LogDatetime = styled(FormRemark)`
  font-size: 12px;
  line-height: 18px;
`;

const DownloadBtn = styled.button`
  flex-shrink: 0;
  padding: 7.5px 20px;
  background-color: var(--aia-bx-white);
  color: var(--aia-bx-dark-blue);
  border: 1px solid var(--aia-bx-blue-2);
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  visibility: visible;
  justify-content: center;
  text-decoration: none;
  
  display: flex;
  align-items: center;
  
  ${props => props.$disabled ? `
      cursor: not-allowed;
      opacity: 0.3;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: var(--aia-bx-blue-5);
    }
  `
  };
`;

export default RequestStatus;